import { render, staticRenderFns } from "./Empresa.vue?vue&type=template&id=94480720&scoped=true&"
import script from "./Empresa.vue?vue&type=script&lang=js&"
export * from "./Empresa.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "94480720",
  null
  
)

export default component.exports